<div class="container gray-200">
    <section>
        <div class="content-band max-w1440">
            <ul class="tile-container fade">
                <li>
                    <a href="javascript:void(0)" (click)="navigateProfileSearch()"
                        class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                        <div class="tile--img">
                            <div class="img--position">
                            <i class="fa-solid fa-user-magnifying-glass"></i>
                            </div>
                        </div>
                        <div class="tile--content">
                            <header class="header--tile">
                                <div class="tile--title">New Profile Approval Search</div>
                            </header>
                            <p class="p--tile">
                                Search for new user profiles pending approval
                            </p>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0)" (click)="navigateChangeSearch()"
                        class="a--tile tile--lrg white hover--shadow" style="border-radius:calc(8px)">
                        <div class="tile--img">
                            <div class="img--position">
                                <i class="fa-solid fa-person-circle-check"></i>
                            </div>
                        </div>
                        <div class="tile--content">
                            <header class="header--tile">
                                <div class="tile--title">Change Profile Approval Search</div>
                            </header>
                            <p class="p--tile">
                               Search for name change requests pending approval
                            </p>
                        </div>
                    </a>
                </li>                
            </ul>
        </div>
            
       
    </section>
</div>